module.exports = __webpack_public_path__ + "img/2x.0637e68.jpg";